import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock, Mail, Phone, MessageSquare, Sparkles } from "lucide-react";
import { useState } from "react";
import { TIER_NAMES } from "@/lib/subscriptionFeatures";

interface PendingUpgradeBannerProps {
  requestedTier: string;
  requestedAt: string;
  onDismiss?: () => void;
}

export const PendingUpgradeBanner = ({ requestedTier, requestedAt, onDismiss }: PendingUpgradeBannerProps) => {
  const [open, setOpen] = useState(true);
  
  const tierName = TIER_NAMES[requestedTier as keyof typeof TIER_NAMES] || requestedTier;

  const handleClose = () => {
    setOpen(false);
    onDismiss?.();
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <div className="p-2 rounded-full bg-primary/10">
              <Clock className="h-6 w-6 text-primary animate-pulse" />
            </div>
            <DialogTitle className="text-xl">Pendaftaran {tierName} Sedang Diproses</DialogTitle>
          </div>
          <DialogDescription asChild>
            <div className="text-base space-y-4">
              <p>
                Terima kasih telah mendaftar paket <strong className="text-foreground">{tierName}</strong>! 
                Tim kami sedang memproses permintaan Anda.
              </p>
              
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="font-medium flex items-center gap-2 text-foreground">
                  <Sparkles className="h-4 w-4 text-primary" />
                  Kami akan menghubungi Anda melalui:
                </p>
                <ul className="space-y-1 ml-6">
                  <li className="flex items-center gap-2">
                    <Mail className="h-4 w-4" /> Email
                  </li>
                  <li className="flex items-center gap-2">
                    <Phone className="h-4 w-4" /> Telepon
                  </li>
                  <li className="flex items-center gap-2">
                    <MessageSquare className="h-4 w-4" /> WhatsApp
                  </li>
                </ul>
              </div>

              <p className="text-muted-foreground">
                Sementara menunggu, Anda dapat menggunakan fitur <strong className="text-foreground">Free Tier</strong> kami 
                untuk mulai melaporkan hazard dan membangun budaya keselamatan di tempat kerja Anda.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex justify-end mt-4">
          <Button onClick={handleClose}>
            Mulai Menggunakan SORIN
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
